var map = {
	"./cs/privacypolicy_coges.html": "2578",
	"./de/privacypolicy_coges.html": "f06f",
	"./en/privacypolicy_coges.html": "e28b",
	"./es/privacypolicy_coges.html": "33b0",
	"./fr/privacypolicy_coges.html": "18ca",
	"./it/privacypolicy_coges.html": "12f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a5e";